<!-- src/components/AppFooter.vue -->
<template>
  <div class="section-card mt-20">
    <div class="section-body footer-content">
      <div class="footer-text">
        <div class="copyright-text">
          © 2020‑2026 N.Ships Co., Limited (China)
        </div>
        <div class="copyright-sub">
          Maritime Solutions in China Ports
        </div>
        <div class="beian-wrapper">
          <a 
            href="https://beian.mps.gov.cn/#/query/webSearch?code=32060202002982" 
            rel="noreferrer" 
            target="_blank" 
            class="beian-link ga-link"
          >
            <img src="/beian.png" alt="公安备案图标" class="ga-icon">
            苏公网安备32060202002982号
          </a>
          <span class="beian-separator">|</span>
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            class="beian-link"
          >
            苏ICP备2021052578号
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
/* ============================================================
   底栏容器
   ============================================================ */
.section-body {
  padding: 12px 20px;
  font-size: 12px;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.footer-text {
  text-align: center;
  color: #909399;
  line-height: 1.8;
  width: 100%;
}

/* ============================================================
   版权文字
   ============================================================ */
.copyright-text {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
}

.copyright-sub {
  font-size: 12px;
  color: #a8b0b8;
  margin-bottom: 2px;
}

/* ============================================================
   备案号容器 - 使用 flex 确保对齐
   ============================================================ */
.beian-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;
  margin-top: 2px;
  font-size: 12px;
}

/* ============================================================
   备案链接通用样式
   ============================================================ */
.beian-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: #a8b0b8;
  transition: color 0.3s ease;
  font-size: 12px;
}

.beian-link:hover {
  color: #409eff;
}

/* ============================================================
   公安备案 - 图标 + 文字
   ============================================================ */
.ga-link {
  gap: 4px;
}

/* 公安备案图标样式 */
.ga-icon {
  height: 16px;
  width: auto;
  display: inline-block;
  flex-shrink: 0;
}

/* ============================================================
   分隔符
   ============================================================ */
.beian-separator {
  display: inline-block;
  color: #606266;
  margin: 0 6px;
  font-size: 12px;
  user-select: none;
}

/* ============================================================
   响应式：小屏幕换行
   ============================================================ */
@media (max-width: 480px) {
  .beian-wrapper {
    flex-wrap: wrap;
    gap: 4px 0;
  }

  .beian-separator {
    display: none;
  }

  .copyright-text {
    font-size: 12px;
  }

  .copyright-sub {
    font-size: 11px;
  }

  .beian-link {
    font-size: 11px;
  }

  .ga-icon {
    height: 14px;
  }
}

/* ============================================================
   超小屏幕：完全纵向排列
   ============================================================ */
@media (max-width: 360px) {
  .beian-wrapper {
    flex-direction: column;
    gap: 2px 0;
  }

  .beian-separator {
    display: none;
  }
}
</style>